<template>
  <vs-row vs-justify="center" id="organizations-box">

    <!-- DELETE PROMPT -->
            <div class="centerx con-exemple-prompt">
              <vs-prompt @accept="deleteOrganization(selected.harif_id)" color="danger" :active.sync="activeDeletePrompt">
                <div class="con-exemple-prompt">
                  Are you sure to delete
                  {{selected.name}}
                  gateways ?
                </div>
              </vs-prompt> 
            </div>

    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <div slot="header">
            <vs-row>
                <vs-col>
                    <vs-card vs-offset="9" vs-w="3">
                    <vs-button
                        id="add-organization"
                        icon="add"
                        color="primary"
                        @click="createOrganization"
                    >{{$t('Harif.AddButton')}}</vs-button>
                    </vs-card>
                </vs-col>
            </vs-row>
            <br>
            <vs-table
              :sst="true"
              @search="handleSearch"
              @selected="handleSelected"
              v-model="selected"
              :total="totalItems"
              max-items="10"
              search
              :data="gateways"
            >
              <template slot="thead">
                <vs-th sort-key="contactname" >{{$t('Harif.Name')}}</vs-th>
                <vs-th sort-key="joindate"  >{{$t('Harif.ID')}}</vs-th>
                <vs-th sort-key="joindate"  >{{$t('Harif.Count')}}</vs-th>
                <vs-th sort-key="book_id" >{{$t('Harif.Date')}}</vs-th>
                <vs-th>{{$t('Organization.Table.Options')}}</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
               
                  <vs-td :data="data[indextr].name">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <h5 class="mb-0 font-16">{{ data[indextr].name}}</h5>
                        <span class="text-muted">{{ data[indextr].name }}</span>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].harif_id">
                    <div
                      class="d-flex align-items-center"
                    >{{ data[indextr].harif_id }}</div>
                  </vs-td>

                  <vs-td :data="data[indextr].businesses_count">
                    <div
                      class="d-flex align-items-center"
                    >
                        <i class="mdi mdi-hospital-building  mr-2 display-8"></i>
                        {{ data[indextr].businesses_count }}
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    <div
                      class="d-flex align-items-center"
                    >{{ data[indextr].created_at }}</div>
                  </vs-td>

                  <vs-td>
                    
                    <div class="btn-alignment">
                      <vs-button
                            id="edit-customer-button"
                            radius
                            color="warning"
                            type="border"
                            icon="edit"
                            @click="updateOrganization(data[indextr].harif_id)"
                          ></vs-button>
                    
                      
                      <vs-button
                        radius
                        color="danger"
                        type="border"
                        icon="delete"
                        @click="deleteOrganizationPrompt(data[indextr].harif_id)"
                      ></vs-button>


                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination
              @change="handleChangePage"
              :total="totalPages"
              v-model="currentPage"
            ></vs-pagination>
            <!-- <vs-pagination @change="handleChangePage" :total="totalPages"  v-model="currentPage"></vs-pagination> -->
        </div>
      </vs-card>
    </vs-col>
  </vs-row>

  
</template>

<script>
import {harifService} from '../../_services';
import router from "../../_helpers/router";
import moment from 'moment'

export default {
    name: "HarifGateways",
    data: () => ({
        title: "HarifGateways",
        activeDeletePrompt: false,
        totalPages: 0,
        currentPage: 1,
        name:"",
        selected: {},
        gateways: [],
        importModal: {
        file: null,
        
        }
    }),
    methods: {
        notify(title, text, type) {
            this.$vs.notify({
                color: type,
                title: title,
                text: text
            });
        },
        showLoading() {
            this.$vs.loading({
                container: "#organizations-box",
                scale: 0.6
            });
        },
       
        hideLoading() {
            this.$vs.loading.close("#organizations-box > .con-vs-loading");
        },

        handleChangePage() {
  this.showLoading();
  harifService
    .filter({ current_page: this.currentPage, keyword: this.searchKeyword })
    .then(function(data) {
      this.gateways = data.harif_gateways.data;
    }.bind(this))
    .finally(() => {
      this.hideLoading();
    });
},

handleSearch(name) {
  this.searchKeyword = name;



  if (name == "") {
    this.showLoading();
    harifService
          .filter({name :""})
          .then(
            function (data) {
              this.gateways = data.harif_gateways.data;
            this.totalItems = data.harif_gateways.total;
            this.maxItems = data.harif_gateways.per_page;
            this.totalPages = data.harif_gateways.last_page;
          
        }.bind(this)
      )
      .finally(
        function () {
          this.hideLoading();
        }.bind(this)
      );
  } else {
      
      this.showLoading();
      harifService
        .filter({name : name})
        .then(
          function (data) {
            this.gateways = data.harif_gateways.data;
            this.totalItems = data.harif_gateways.total;
            this.maxItems = data.harif_gateways.per_page;
            this.totalPages = data.harif_gateways.last_page;

          }.bind(this)
        )
        .finally(
          function () {
            this.hideLoading();
          }.bind(this)
        );
    }
     
  },


        createOrganization() {
            this.$router.push("/harif_sms_gateways/create");
        },
        deleteOrganizationPrompt(item) {
          this.selected = item;
          this.activeDeletePrompt = true;
        },
        deleteOrganization(id){
          this.showLoading();
          harifService
            .deleteGateway(id).then(
              function(data) {
                this.handleChangePage(this.currentPage);
                this.notify(
                  this.$t("Toasts.Successful"),
                  this.$t("Harif.DeleteSuccess"),
                  "success"
                );
              }.bind(this)
            )
            .catch(
              function() {
                this.notify(
                  this.$t("Toasts.Error"),
                  this.$t("Harif.DeleteFailt"),
                  "danger"
                );
              }.bind(this)
            )
            .finally(
              function() {
                this.hideLoading();
                this.activeDeletePrompt = false;
                router.go();
              }.bind(this)
            );
          
        },
        showOrganization(harif_id){
          this.$router.push('/harif_sms_gateways/show/'+harif_id);
        },
        updateOrganization(harif_id){
          this.$router.push('/harif_sms_gateways/update/'+harif_id);
        }
    },
    mounted() {
      this.showLoading();
        harifService.filter().then(function (data) {
            this.gateways = data.harif_gateways.data.map(obj => {
                obj.created_at= moment(obj.created_at).format('MM/DD/YYYY hh:mm:ss');
                return obj;
            });
            this.totalItems = data.harif_gateways.total;
            this.maxItems = data.harif_gateways.per_page;
            this.totalPages = data.harif_gateways.last_page;
        }.bind(this))
            .finally(() => {
                this.hideLoading();
            });
    }
}
</script>

<style>

</style>